import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AccountComponent } from "./account/account.component";
import { NotificationSettingsComponent } from "./notification/notification-settings.component";
import { SecuritySettingsComponent } from "./security/security-settings.component";
import { MySettingsComponent } from "./my-settings.component";
import { AuthGuardService } from './auth/AuthGuardService';

const routes: Routes = [
  {
    path: "",
    component: MySettingsComponent,    
    canActivate: [AuthGuardService],
    children: [
      {
        path: "account",
        component: AccountComponent
      },
      {
        path: "security",
        component: SecuritySettingsComponent,
      },
      {
        path: "security/:e",
        component: SecuritySettingsComponent,
      },
      {
        path: "notification",
        component: NotificationSettingsComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class MySettingsRoutingModule {}

export const routedComponents = [
  AccountComponent,
  SecuritySettingsComponent,
  NotificationSettingsComponent
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/my-settings-routing.module.ts